import { render, staticRenderFns } from "./SpecialistAppointments.vue?vue&type=template&id=fcf79c46&scoped=true"
import script from "./SpecialistAppointments.vue?vue&type=script&lang=js"
export * from "./SpecialistAppointments.vue?vue&type=script&lang=js"
import style0 from "./SpecialistAppointments.vue?vue&type=style&index=0&id=fcf79c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf79c46",
  null
  
)

export default component.exports